import { render, staticRenderFns } from "./personalEducationInfo.vue?vue&type=template&id=069c1eb8&scoped=true&"
import script from "./personalEducationInfo.vue?vue&type=script&lang=js&"
export * from "./personalEducationInfo.vue?vue&type=script&lang=js&"
import style0 from "./personalEducationInfo.vue?vue&type=style&index=0&id=069c1eb8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "069c1eb8",
  null
  
)

export default component.exports